export const baseUrl = "https://nodebemycred.supagrow.in";

export const contact = "api/storecontactapi";